import { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import OrganigramaAreaDataService from './services/organigramaarea.service';
import { Container, Row, Tooltip, Table, Col, FormLabel, FormControl, Button } from 'react-bootstrap';
import Sidebar from "./Sidebar";
import ExportSidebar from "./ProSideBar";
import { dtFormatter, PageHeader } from './AuxiliaryFunctions';
import { useSelector } from "react-redux";
import MessageBox from './MessageBox';
import CompetenciasAreasJuez from './CompetenciasAreasJuez';

const ListaDeCompetenciasUsuario = () => {
  let params = useParams();
  let userid = params.userid; // it might not be the current user

  const { user: currentUser } = useSelector((state) => state.auth);	

  const [errmessage, setErrmessage] = useState("");
  const [showerror, setShowerror] = useState(false);
  const [succmessage, setSuccmessage] = useState("");
  const [showsuccess, setShowsuccess] = useState(false);

  const [listofcompetenciasusuario, setListofJCompetenciasUsuario] = useState([]);
  const [organigrama, setOrganigrama] = useState({});
  const [competencia, setCompetencia] = useState({});

  useEffect(() => {   
    OrganigramaAreaDataService.getListCompetenciasUsuario(currentUser.id)
      .then(resp => {
        console.log(resp.data);
        setListofJCompetenciasUsuario(resp.data);
      })
      .catch((e) => {
        if (e.response.status == 401) {
          dispatch(logout())
          .then(() => {
            window.location.reload();
          });
        }
        else {
          console.log(e.response.data);
          setSuccmessage("");
          setShowsuccess(false);
          setErrmessage(e);
          setShowerror(true);
        }
      });      
  }, []);  

  return (
    <>
    <Sidebar />
    <div style={{display:'flex', flexDirection:'row', gap:'10px'}}>      
      
      <ExportSidebar roles={currentUser.roles}/>
      <Container>
        <PageHeader />  
        <Row className='mb-2 d-flex'>
          <h5 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>Lista de competencias donde apareces</h5>
        </Row> 
        <Row>
          <ListaCompUsuario listOf={listofcompetenciasusuario} currentUser={currentUser}/>
        </Row>        
      </Container>       
    </div>   

    <Row className='mt-2'>
      {showerror && (
        <MessageBox show={true} showerror={showerror} errmessage={errmessage}
          onHide={() => {
            setShowerror(false)
          }}
        />
      )}
      {showsuccess && (
        <MessageBox show={true} showsuccess={showsuccess} succmessage={succmessage}
          onHide={() => {
          setShowsuccess(false);
          window.location.reload();
        }}
        />
      )}
    </Row>      
    </>
  )
};

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'8%'}}>Competencia</th>
        <th className='d-none d-sm-table-cell' style={{width:'20%'}}>Descripción competencia</th>
        <th style={{width:'8%'}}>Fecha inicio</th>
        <th className='d-none d-sm-table-cell' style={{width:'8%'}}>Fecha fin</th>
        <th style={{width:'8%'}}>Ver áreas</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {  
  
  if (props.listOf) {
    
    const rows = props.listOf.map((row, index) => { 
      return (
        <>
        <tr key={index}>        
          <td>
            {row.nombrecompetencia}
          </td>
          <td className='d-none d-sm-table-cell'>
            {row.descripcioncompetencia}
          </td>          
          <td>  
            {dtFormatter(new Date(row.fechainicio),1)}
          </td>
          <td className='d-none d-sm-table-cell' >  
            {dtFormatter(new Date(row.fechafin),1)}
          </td>   
          <td>
            <CompetenciasAreasJuez 
              organigramaid={row.id}  // organigramaId
              competenciaid={row.compid} 
              userid={props.currentUser.id}
            />
          </td>
        </tr>
        </>      
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const ListaCompUsuario = (props) => {        
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline"}} striped bordered hover size="sm">
            <TableHeader/>
            <TableBody listOf={props.listOf} currentUser={props.currentUser}/>
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
};

export default ListaDeCompetenciasUsuario;